const JOURNEY_SNAPSHOT_KEY = 'inlic_journey_snapshot_v1';

const getSessionStorage = () => {
  try {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      return window.sessionStorage;
    }
  } catch {
    // Ignore storage access issues.
  }
  return null;
};

const sanitizeJourneyState = (journeyState) => {
  if (!journeyState || typeof journeyState !== 'object' || Array.isArray(journeyState)) {
    return null;
  }
  const clone = { ...journeyState };
  // Runtime-only values should not be restored from snapshot.
  delete clone.premiumLoading;
  delete clone.premiumLoadingCount;
  delete clone.premiumError;
  return clone;
};

export const saveJourneySnapshot = (journeyState) => {
  const storage = getSessionStorage();
  if (!storage) return;
  const sanitized = sanitizeJourneyState(journeyState);
  if (!sanitized) return;
  try {
    storage.setItem(
      JOURNEY_SNAPSHOT_KEY,
      JSON.stringify({
        version: 1,
        savedAt: Date.now(),
        journey: sanitized,
      }),
    );
  } catch {
    // Ignore quota / serialization errors.
  }
};

export const loadJourneySnapshot = () => {
  const storage = getSessionStorage();
  if (!storage) return null;
  try {
    const raw = storage.getItem(JOURNEY_SNAPSHOT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || parsed.version !== 1) return null;
    return sanitizeJourneyState(parsed.journey);
  } catch {
    return null;
  }
};

export const clearJourneySnapshot = () => {
  const storage = getSessionStorage();
  if (!storage) return;
  try {
    storage.removeItem(JOURNEY_SNAPSHOT_KEY);
  } catch {
    // Ignore storage errors.
  }
};

